import { Outlet } from "react-router-dom";

const BooksPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default BooksPageLayout;